import React, {useState} from "react";
import {useForm, SubmitHandler, FormProvider} from "react-hook-form";
import {useNavigate, useSearchParams} from "react-router-dom";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {useAuth} from "hooks/useAuth";
import {useServerErrors} from "hooks/useServerErrors";
import FormField from "shared/form/FormField";
import ErrorsList from "shared/ui/ErrorsList";
import {APIPostResetPassword} from "../api/passwordReset";

export interface IFormChangePassword {
    domain: string;
    email: string;
    password: string;
    confirm_password: string;
}

const schema = yup
    .object({})
    .required();

const ChangePasswordForm = ({type} : {type: "school" | "teacher"}) => {
    const {update} = useAuth();
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState<string>("");

    const queryParams = {
        token: searchParams.get("token"),
        email: searchParams.get("email"),
        domain: searchParams.get("domain"),
    };

    const methods = useForm<IFormChangePassword>({
        resolver: yupResolver(schema),
    });
    const { handleServerErrors } = useServerErrors<IFormChangePassword>(methods.setError);

    const handleResetPasswordError = (err: any) => {
        if (err?.response?.status === 400) {
            const errors = err.response.data.data;
            handleServerErrors(errors);
            if (!errors.password && !errors.confirm_password) {
                setErrorMessage(errors.value);
            }
        } else if (err.response?.status === 404) {
            setErrorMessage(err.response.data.data.value);
        } else {
            update("error", { show: true, code: "A001" });
        }
    };

    const onSubmit: SubmitHandler<IFormChangePassword> = (data) => {
        update("loading", {show: true, modal: true});

        APIPostResetPassword({
            ...queryParams,
            password: data.password,
            password_confirmation: data.confirm_password,
        })
            .then((response) => {
                if (response.data.success) {
                    methods.clearErrors();
                    setErrorMessage("");
                    setSearchParams({});

                    const redirectUrl = type === "school" ? "/login" : "/login/profesori";

                    update("error", {
                        show: true,
                        message: response.data.data.value,
                        title: "",
                        icon: "fat face-smile",
                        closable: true,
                        button: "ÎNCHIDE",
                        returnFunction: () => navigate(redirectUrl),
                    });
                } else {
                    update("error", {show: true, code: "A002"});
                }
            })
            .catch(handleResetPasswordError)
            .finally(() =>  update("loading", {show: false}));
    };

    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)} noValidate>
                <Box py={1}>
                    <FormField
                        name="password"
                        type="password"
                        defaultValue=""
                        label="Parolă nouă"
                        autoComplete="password"
                        errorMessage={methods.formState.errors.password?.message}
                        error={!!methods.formState.errors.password?.message}
                    />
                </Box>
                <Box py={1}>
                    <FormField
                        name="confirm_password"
                        type="password"
                        label="Confirmă parola"
                        errorMessage={methods.formState.errors.confirm_password?.message}
                        error={!!methods.formState.errors.confirm_password?.message}
                    />
                </Box>
                <Box sx={{mt: 1, mb: 3}}>
                    <Button type="submit" variant="contained">Schimbă parola</Button>
                    <ErrorsList show={errorMessage !== ""}>{errorMessage}</ErrorsList>
                </Box>
            </form>
        </FormProvider>
    );
};

export default ChangePasswordForm;
